module.exports = __webpack_public_path__ + "9c92fc8436f4aa8574087b147d8e05c8.fbx";